/* unplugin-vue-components disabled */import script from "./HostContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HostContent.vue?vue&type=script&setup=true&lang=ts"

import "./HostContent.vue?vue&type=style&index=0&id=3faadbec&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3faadbec"]])

export default __exports__